
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hodari",
      function () {
        return require("private-next-pages/hodari.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hodari"])
      });
    }
  